// Bespoke billing experience(s) that need to be handled differently by Finance team only.
export const SEGMENT_KEY_MANUAL_BILLING_EXPERIENCE =
  "manual-billing-management";
export const FEATURE_FLAG_KEY_MANUAL_BILLING_EXPERIENCE =
  "web_billing_manual_billing_management";

// General kill switch for billing and subscription update operations on an org. Periscope
// uses it to disable the actions that rebuild Zuora rate plans (term, billing frequency,
// currency, end trial, reactivate, coupons), since those re-resolve every charge against
// the product catalog — after the live subscription has already been cancelled — and
// silently drop or re-price anything the catalog doesn't support (FG-6190).
//
// The most common reason an org is flagged is exactly that: api-subscriptions adds orgs to
// the backing segment, "subscriptions-disable-billing-updates", automatically when catalog
// resolution fails. But it is NOT the only reason — orgs are also added by hand (including
// from Periscope's own Segments tab) and for decoupled billing, and other services read the
// same flag for unrelated purposes (api-accounts seat validation, SCIM, reconcile skips).
// Don't state a cause in user-facing copy.
export const FEATURE_FLAG_KEY_DISABLE_BILLING_UPDATES =
  "primary_subscriptions_disable_billing_updates";
